import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AxiosPromise } from '../../../utils/axios.promise';
import { CommonConfig } from '../../../configs/config.common';
import * as moment from 'moment';
import gql from 'graphql-tag';
const base64 = require('base-64');



@Component
export default class VRenewPage extends Vue {
    public data: string = '';
    public configs = new CommonConfig();
    public orderDetail = null;
    public payTerm: any = null;
    public disableBtn: any = null;
    public showFormPop = false;
    public message = '';
    public sid = null;
    public lock = false;
    public disableText = '';
    public priceTotal: any = '';
    public orderCreatedDate: any = null;
    public orderDeliveryDate: any = null;
    public allInvoices: any = null;
    public selInd = 0;
    public getOrderDetailSql = gql`query ($orderId: String!, $app: String!){
        order{
          myOrder(
            orderId: $orderId,
            app: $app,
          )
        }
    }`;
    public showDate(val: string) {
        return moment(val).local().format('YYYY-MM-DD HH:mm');
    }
    public async renew() {
        if (this.lock && !this.allInvoices) {
            return;
        }
        if (this.allInvoices.length) {
            for (let i = 0; i < this.allInvoices.length; i++) {
                if (this.allInvoices[i].unpaid > 0 && this.allInvoices[i].type === 'OUT_INVOICE') {
                    this.$Notice.warning({
                        desc: 'You Still Have Unpaid Bills, Please Pay',
                        title: 'Pay Bill First',
                    });
                    location.href = this.allInvoices[i].link;
                    return;
                }
            }
        }
        const vendorApi = this.configs.vendorService;
        this.lock = true;
        if (this.payTerm) {
            const selTerm = this.payTerm[this.selInd];
            const sName = base64.decode(this.$route.params.receive);
            const fetched = await AxiosPromise.postJson(`${vendorApi}/order/renew`, {
                soName: sName,
                price: selTerm.x_price,
                amount: 1,
                period: selTerm.x_renew_period,
                periodUnit: selTerm.x_renew_period_unit,
                termName: `Renew ${selTerm.x_renew_period} ${selTerm.x_renew_period_unit}`,
                renewProductId: selTerm.x_product_id,
            });
            console.log(fetched);
            if (fetched.status === 200 && fetched.data.code === 200) {
                location.href = fetched.data.data.resInvoicing.data.url;
            } else {
                this.$Notice.warning({
                    desc: 'Request Failed',
                    title: 'Error',
                });
            }
            this.lock = false;
        }
    }
    public async created() {
        const vendorApi = this.configs.vendorService;
        try {
            const url = `${vendorApi}/order/detail?sale_order_name=${this.$route.params.receive}&app=RENEW`;
            const fetched = await AxiosPromise.get(url);
            if (fetched) {
                this.orderDetail = fetched.order;
                this.payTerm = fetched.paymentTerm;
                this.allInvoices = fetched.clientStatement.invSubtotal;
                this.orderCreatedDate = moment.utc(fetched.order.saleOrder.order_create_date).add(12, 'hours').local().format('YYYY-MM-DD HH:mm');
                this.orderDeliveryDate = moment.utc(fetched.order.saleOrder.x_main_delivery_date).local().format('YYYY-MM-DD HH:mm');
            }
        } catch (e) {
            this.$router.push('/not/found');
        }
    }
}
